import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import drEasyApi from "../Api/Customapi";
import axios from "axios";

const fetchCenterBySlug = async (slug) => {
    const response = await drEasyApi.get(`/api/Centers/GetCenterbySlug?Slug=${slug}`);
  return response.data;
};

export const useCenterQuery = (slug=null) => {

  return useQuery({
    queryKey: ["center", slug],
    queryFn: () => fetchCenterBySlug(slug),
    enabled: !!slug, // avoid running before slug is available
    retry: false,
  });
};
